import { ApplyParams } from '~/business/Apply/types';
import { callParseCloudFunctionProxy } from '~/utils/parse';

export type JobOfferApplyParams = ApplyParams & {
  jobOfferId: string;
};

export const jobOfferApply = async ({ businessUnit, ...body }: JobOfferApplyParams): Promise<boolean> => {
  const { data } = await callParseCloudFunctionProxy<boolean>(businessUnit, 'WebJobOfferApply', body);
  return Boolean(data);
};
